import { render, staticRenderFns } from "./Coordinate.vue?vue&type=template&id=a470bc18"
import script from "./Coordinate.vue?vue&type=script&lang=js"
export * from "./Coordinate.vue?vue&type=script&lang=js"
import style0 from "./Coordinate.vue?vue&type=style&index=0&id=a470bc18&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports